import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Writing",
  "description": "",
  "published": "2008-08-11T00:00:00.000Z",
  "redirect_from": ["/blog/writing/swizec/84"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sometimes I like to think of myself as a writer, but as my girlfriend is wont to pointing out I must actually `}{`_`}{`write `}{`_`}{`something now and anon to be considered a writer, otherwise I'm just a regular old bloke. And I do admit that I write far too little so last week I opened a `}<a parentName="p" {...{
        "href": "http://forum.seraph-inn.com/index.php?showtopic=6437"
      }}>{`thread on a forum`}</a>{` asking for tuples of four words and a sentence to get me to writing. So far it's actually been very helpful, I've managed to write three short stories in a week, which is about thrice the amount I usually write in two or three months.`}</p>
    <p>{`However, I've noticed, that writing like this has a flaw. Sure it gets you writing and yes it's a good motivator, but what you produce, at least what `}<strong parentName="p">{`I`}</strong>{` produce is utter trash without even a hint of any real meaning, let alone deepness and susbstantiality. All they are is a funky little story that spurred out of a few random words and a phrase.`}</p>
    <p>{`When I'm writing for me, that is when I wait and procrastinate and then wait some more and then after something's been tossing around my thick skull for a few months and finally get down to writing it what comes out is much deeper, much more meaningful and actually says something beyond being just a lame old trash story. Although I must say style-wise it's not much better.`}</p>
    <p>{`See the problem I have with style isn't necessarily that my style of writing is bad per se, it's actually very nice to read and sucks you right in wanting to learn more and more of the story, or so I'm told. The problem lies elsewhere, it's that all my characters lack a certain life, my dialogues lack a certain organic quality to them. Everything I write down feels somewhat out of place since the story does flow naturally, but everyone in it is stiff as wood and when they talk it's everything but natural.`}</p>
    <p>{`This stems, I think, from similar issues Lovecraft had and I would hate to fall in the same pit he did with his writing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      